module.exports = __webpack_public_path__ + "img/PC_logo.edce2fe1.png";